<template>
	<app-modal :sleep="loading" :maxWidth="980" name="files-uploader" :click-to-close="false" @beforeOpen="beforeOpen">

		<template v-slot:title>Подготовка изображений</template>

		<template v-slot="{params}">

<!--			<div class="row">-->
<!--				<div class="col-md-5">-->
<!--					<h4 class="app-modal__title" style="font-size: 1.5rem; margin: 3px 0 0 0;">Подготовка изображений</h4>-->
<!--				</div>-->
<!--				<div class="col-12 col-md-6 mt-3 mt-md-0">-->
<!--					<div class="d-flex">-->
<!--						<input type="text" class="form-control py-2" @paste="pasteImageEvent" placeholder="image url / copied image in clipboard" style="font-size: 12px;">-->
<!--						<span class="align-self-center mx-3">or</span>-->
<!--						<button type="button" class="btn btn-sm btn-primary" style="white-space: nowrap; line-height: 0.8;" @click="tryFilePaste">-->
<!--							try to paste<br>-->
<!--							<small style="font-size: 12px;">from clipboard</small>-->
<!--						</button>-->
<!--						<button type="button" class="btn btn-sm btn-light ms-2" @click="showInfo = !showInfo">INFO</button>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->

<!--			<div v-if="showInfo" class="small mt-3 ps-3" style="border-left: 4px solid #1a1a1a; line-height: 1;">-->
<!--				<p class="mb-1">Способы загрузки изображения:</p>-->
<!--				<p class="m-0">-->
<!--					вставка с помощью <strong>ссылки</strong>;&nbsp;-->
<!--					вставка через <strong>copy/paste</strong>;&nbsp;-->
<!--					загрузка изображения <strong>с устройства &darr;</strong>-->
<!--				</p>-->
<!--			</div>-->

			<div class="mx-n2 mx-sm-0">
				<div class="row g-2 g-sm-4">
					<div v-for="(file, key) in files" :key="'file'+key" class="col-6 col-sm-4 col-md-3">

						<div class="file-preview" :class="{
							'file-preview_unchecked': !file.checked && file.state === STATE_PREVIEW,
							'file-preview_loading': file.state === STATE_UPLOADING,
							'file-preview_success': file.state === STATE_UPLOADED_DONE,
							'file-preview_error': file.state === STATE_UPLOADED_ERROR
						}">
							<figure class="file-preview__figure" data-unchecked-text="файл не будет загружен">
								<img :src="file.image" class="file-preview__image" @load="onFileLoad(file)">
							</figure>

							<div class="file-preview__body">
								<div class="hstack gap-1">
									<div>
										<input type="text" v-model="file.comment" class="form-control form-control-sm" placeholder="Подпись">
									</div>
									<div v-if="file.state !== STATE_UPLOADED_DONE">
										<input class="form-check-input file-preview__checkbox" v-model="file.checked" type="checkbox">
									</div>
								</div>
							</div>
						</div>

					</div>
					<div class="col-6 col-sm-4 col-md-3">
						<label class="file-choose btn btn-link bg-light d-flex flex-column align-items-center justify-content-center h-100 p-3 text-decoration-none" style="line-height: 1.1;">
							<input type="file" accept="image/*" @change="(event) => addFilesFromPicker(event.target.files)" multiple>
							<svg width="48" height="48" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
								<path fill="currentColor" d="M18.5 20C18.5 20.275 18.276 20.5 18 20.5H12.2678C11.9806 21.051 11.6168 21.5557 11.1904 22H18C19.104 22 20 21.104 20 20V9.828C20 9.298 19.789 8.789 19.414 8.414L13.585 2.586C13.57 2.57105 13.5531 2.55808 13.5363 2.5452C13.5238 2.53567 13.5115 2.5262 13.5 2.516C13.429 2.452 13.359 2.389 13.281 2.336C13.2557 2.31894 13.2281 2.30548 13.2005 2.29207C13.1845 2.28426 13.1685 2.27647 13.153 2.268C13.1363 2.25859 13.1197 2.24897 13.103 2.23933C13.0488 2.20797 12.9944 2.17648 12.937 2.152C12.74 2.07 12.528 2.029 12.313 2.014C12.2933 2.01274 12.2738 2.01008 12.2542 2.00741C12.2271 2.00371 12.1999 2 12.172 2H6C4.896 2 4 2.896 4 4V11.4982C4.47417 11.3004 4.97679 11.1572 5.5 11.0764V4C5.5 3.725 5.724 3.5 6 3.5H12V8C12 9.104 12.896 10 14 10H18.5V20ZM13.5 4.621L17.378 8.5H14C13.724 8.5 13.5 8.275 13.5 8V4.621Z"/>
								<path fill="currentColor" d="M12 17.5C12 14.4624 9.53757 12 6.5 12C3.46243 12 1 14.4624 1 17.5C1 20.5376 3.46243 23 6.5 23C9.53757 23 12 20.5376 12 17.5ZM7.00065 18L7.00111 20.5035C7.00111 20.7797 6.77725 21.0035 6.50111 21.0035C6.22497 21.0035 6.00111 20.7797 6.00111 20.5035L6.00065 18H3.4956C3.21973 18 2.99609 17.7762 2.99609 17.5C2.99609 17.2239 3.21973 17 3.4956 17H6.00046L6 14.4993C6 14.2231 6.22386 13.9993 6.5 13.9993C6.77614 13.9993 7 14.2231 7 14.4993L7.00046 17H9.49659C9.77246 17 9.99609 17.2239 9.99609 17.5C9.99609 17.7762 9.77246 18 9.49659 18H7.00065Z"/>
							</svg>
							<small class="mt-1 d-block">с устройства</small>
						</label>
					</div>
				</div>
			</div>

			<div class="d-block d-md-flex align-items-center gap-4 mt-5">
				<div>
					<span class="text-muted">Всего:</span>
					{{files.length}}
				</div>
				<div>
					<span class="text-muted">Выбрано для загрузки:</span>
					{{checkedFiles.length}}
				</div>
				<div>
					<span class="text-muted">Загружено:</span>
					{{uploadedFiles.length}}
				</div>
				<div>
					<span class="text-muted">Ошибок:</span>
					{{errorFiles.length}}
				</div>
				<div class="ms-auto mt-3 mt-md-0">
					<div class="d-flex justify-content-between gap-3">
						<button type="button" class="btn btn-primary" @click="uploadSelected({onFileSave: params.onFileSave})" :disabled="!checkedFiles.length">Загрузить</button>
						<button type="button" class="btn btn-outline-dark" @click="$vfm.hide('files-uploader')">
							{{uploadedFiles.length ? 'Закрыть' : 'Отмена'}}
						</button>
					</div>
				</div>
			</div>

		</template>


	</app-modal>
</template>
<script>
import { useToast } from 'vue-toastification'

export default {
	setup() {
		const toast = useToast();

		return {
			toast,

			STATE_PREVIEW: 0,
			STATE_UPLOADING: 1,
			STATE_UPLOADED_DONE: 2,
			STATE_UPLOADED_ERROR: 3,
		}
	},
	data() {
		return {
			loading: false,
			requestUrl: null,
			showInfo: false,

			files: []
		}
	},
	computed: {
		checkedFiles() {
			return this.files.filter(item => item.checked && item.state === this.STATE_PREVIEW);
		},

		uploadedFiles() {
			return this.files.filter(item => item.state === this.STATE_UPLOADED_DONE);
		},

		errorFiles() {
			return this.files.filter(item => item.state === this.STATE_UPLOADED_ERROR);
		}
	},
	methods: {
		beforeOpen(e) {
			const params = e.ref.params.value;
			const files = params.files;

			this.requestUrl = params.requestUrl;

			if (files instanceof FileList) {
				this.addFilesFromPicker(files);
			} else {
				this.files = Array.isArray(params.files) ? params.files : [];
			}
		},

		tryFilePaste() {

			if (!navigator.clipboard.read) {
				alert(`Paste by button are not supported by this browser :(

Please try to  use "paste" command from context menu of the field`);
				return;
			}

			navigator.clipboard.read().then(items => {

				for (let i = 0; i < items.length; i++) {
					const item = items[i];

					for (const type of item.types) {
						if (type.indexOf('image') === 0) {
							item.getType(type).then(blob => {
								alert(blob.type + ' ' + blob.size);
								this.addFilesFromPicker([blob]);
							}).catch(err => {
								alert('1::' + err);
							});
						}
					}

				}
			}).catch(err => {
				alert('2::' + err);
			});

		},

		pasteImageEvent(e) {
			const items = e.clipboardData.items;

			for (let i = 0; i < items.length; i++) {
				const item = items[i];

				if (item.kind === 'file' && item.type.indexOf('image') === 0) {
					const file = item.getAsFile();

					e.target.value = '';

					// alert(file);
					// alert(file.name + ' ' + file.type);
					//
					// this.files.push({
					// 	state: this.STATE_PREVIEW,
					// 	image: URL.createObjectURL(file),
					// 	object: null,
					// 	checked: true,
					// 	comment: ''
					// });

					const reader = new FileReader();

					reader.readAsDataURL(file);

					reader.onload = () => {
						this.files.push({
							state: this.STATE_PREVIEW,
							image: reader.result,
							object: file,
							checked: true,
							comment: ''
						});

						/*fetch(e.target.result)
							.then(res => {
								res.blob().then(blob => {
									this.addFilesFromPicker([blob]);
								}).catch(err => {
									alert('5::' + err);
								})
							}).catch(err => {
								alert('3::' + err);
							})*/
					}

					reader.onerror = function(err) {
						alert('4::' + err);
					}

					break;
				}
			}
		},

		addFilesFromPicker(files) {
			this.files = this.files.concat(
				Array.from(files).map(fileObject => {
					return {
						state: this.STATE_PREVIEW,
						image: URL.createObjectURL(fileObject),
						object: fileObject,
						checked: true,
						comment: ''
					}
				})
			);
		},

		uploadSelected(params = {}) {
			const files = this.checkedFiles;

			if (!files.length || !this.requestUrl) {
				return;
			}

			this.uploadFile(0, files, {
				recursive: true,
				onFileSave: params.onFileSave
			});
		},

		uploadFile(fileIndex, files, params) {
			params = params || {};

			const request = new FormData;
			const file = files[fileIndex];

			file.state = this.STATE_UPLOADING;

			request.append('image', file.object);
			request.append('comment', file.comment);

			return this.userapi.post(this.requestUrl, request)
				.then(response => {
					if (!response.hasValidateErrors && response.data.data.id) {
						file.state = this.STATE_UPLOADED_DONE;
						file.checked = false;

						(params.onFileSave) && params.onFileSave('add', response.data.data);
					} else {
						file.state = this.STATE_UPLOADED_ERROR;
					}
				})
				.catch(() => file.state = this.STATE_UPLOADED_ERROR)
				.then(() => {
					if (params.recursive && files[fileIndex + 1]) {
						this.uploadFile(fileIndex + 1, files, params);
					} else {
						this.toast.success(`${this.uploadedFiles.length} файл(ов) загружено`, {
							timeout: 4000
						});
					}
				})
		},

		onFileLoad(file) {
			if (file.type === this.STATE_PREVIEW) {
				URL.revokeObjectURL(file.image) // free memory
			}
		}
	}
}
</script>